import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import GoogleAdPreviewDiscover1 from '../../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewDiscover1'
import MultipleGoogleMediaUpload from '../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { FILE_URL, SQUARE_IMAGE, squareImageWidth, squareImageHeight } from '../../fields'

import { squareImageValidationSchema } from '../../validations'

import useCommonStyles from '../../../../../styles/common/stepForms'

const stepFields = [SQUARE_IMAGE]

function SquareImageStep({ formik, handleStepChange, isStepFieldsValid }) {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  const { values } = formik

  const fileUrl = values[SQUARE_IMAGE][0]?.[FILE_URL]

  const handleContinue = () => {
    handleStepChange(stepFields, values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Upload at least 1 square image')}</div>
      <div className={commonClasses.stepBody}>
        <GoogleAdPreviewDiscover1
          values={values}
          fileUrl={fileUrl}
          width={squareImageWidth}
          height={squareImageHeight}
        />
        <MultipleGoogleMediaUpload
          formik={formik}
          FileItemPath={SQUARE_IMAGE}
          validationSchema={squareImageValidationSchema}
          isStepFieldsValid={isStepFieldsValid}
          addAnotherButtonText={'Add another square image'}
          width={squareImageWidth}
          height={squareImageHeight}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default SquareImageStep
